export enum PlatformTypeEnum {
  MOBILE = 'mobile',
  CLINIC_DASHBOARD = 'clinic_dashboard',
  WEB = 'web',
}
